// src/utils/formatDate.js
import { format, parseISO } from "date-fns";

export function formatDate(value, dateFormat = "dd-MM-yyy") {
  if (!value) return "";                              // nothing to format
  let date;
  // if it's already a Date instance
  if (value instanceof Date) {
    date = value;
  } else {
    // try parsing an ISO string
    date = parseISO(value);
  }
  if (isNaN(date)) return "";                         // still invalid?
  return format(date, dateFormat);
}
